export { default } from "@modules/widgets/integrated_widget"
